import { ModalTemplateCleanComponent } from './modal-template-clean/modal-template-clean.component';
import { ModalTemplateDefaultComponent } from './modal-template-default/modal-template-default.component';
import { ModalTemplateLargeComponent } from './modal-template-large/modal-template-large.component';
import { ModalTemplateNoCloseComponent } from './modal-template-no-close/modal-template-no-close.component';
import { ModalTemplateSmallComponent } from './modal-template-small/modal-template-small.component';

export const ModalTemplate = {
  DEFAULT: ModalTemplateDefaultComponent,
  NO_CLOSE: ModalTemplateNoCloseComponent,
  LARGE: ModalTemplateLargeComponent,
  CLEAR: ModalTemplateCleanComponent,
  SMALL: ModalTemplateSmallComponent,
};
